// extracted by mini-css-extract-plugin
export default {"boxRarities":"BoxRarities_boxRarities__M57WR","boxRarities__grid":"BoxRarities_boxRarities__grid__BVao6"};